import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "mHead",
  computed: {
    ...userVuex.mapState(["isLogin", "balanceInfo", "userInfo", "settingInfo"])
  },
  data() {
    return {
      popEarnTicketShow: false,
      isBuyTicketLoading: false,
      requiredStars: 60,
      isBuyLoading: false,
      popBuyTicketShow: false,
      ticketPriceList: null,
      isBuyTicketListLoading: false
    };
  },
  methods: {
    ...userVuex.mapActions(["getBuyTicketList", "paymentTicket", "paymentDepositStars", "openInvoiceStarPay", "getLoginInfo"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    showPop() {
      this.hapticFeedback();
      this.popEarnTicketShow = true;
    },
    async getTicketPrice() {
      if (this.isBuyTicketListLoading) return;
      this.isBuyTicketListLoading = true;
      const ticketPriceList = await this.getBuyTicketList();
      if (!ticketPriceList) {
        this.isBuyTicketListLoading = false;
        return;
      }
      this.isBuyTicketListLoading = false;
      this.ticketPriceList = ticketPriceList;
    },
    async buyTicket() {
      this.popBuyTicketShow = true;
      await this.getTicketPrice();
    },
    async onPayTicket(item) {
      item.isLoading = true;
      if (this.userInfo.stars < item.stars) {
        const paystarsRes = await this.paymentDepositStars({
          amount: item.stars - this.userInfo.stars
        });
        if (!paystarsRes) {
          item.isLoading = false;
          return;
        }
        console.log("paystarsRes.chainInfo.payment_url", paystarsRes, paystarsRes.chainInfo.payment_url);
        const starRes = await this.openInvoiceStarPay({
          url: paystarsRes.chainInfo.payment_url
        });
        if (!starRes) {
          item.isLoading = false;
          return;
        }
      }
      await this.getLoginInfo();
      const res = await this.paymentTicket({
        priceId: item.id
      });
      if (!res) {
        item.isLoading = false;
        return;
      }
      this.setUserInfo(res.userInfo);
      this.$toasted.clear();
      this.$toasted.success("payment ticket success!");
      item.isLoading = false;
      this.popEarnTicketShow = false;
      this.popBuyTicketShow = false;
    }
  }
};